/**
 * What scrolls the page: on wide screens the panel (the "canvas" stays put and its content scrolls inside it,
 * app.css), on phones the window. Everything that reads or sets the page's scroll position goes through here.
 */
export function scroller(): HTMLElement | null {
  const panel = document.querySelector<HTMLElement>(".main > .panel");
  return panel && /auto|scroll/.test(getComputedStyle(panel).overflowY) ? panel : null;
}
export const scrollTop = () => scroller()?.scrollTop ?? window.scrollY;
export function scrollToTop(top: number) {
  const el = scroller();
  if (el) el.scrollTo({ top }); else window.scrollTo({ top });
}
/** The top of the visible page area in the window (the panel's top edge, or 0). */
export const viewTop = () => scroller()?.getBoundingClientRect().top ?? 0;
